import { render, staticRenderFns } from "./EindB.vue?vue&type=template&id=37ffa589&scoped=true&"
import script from "./EindB.vue?vue&type=script&lang=js&"
export * from "./EindB.vue?vue&type=script&lang=js&"
import style0 from "./EindB.vue?vue&type=style&index=0&id=37ffa589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffa589",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
